module.exports = __webpack_public_path__ + "static/media/landscape-2.8d14a50d.jpg";